import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import underConstruction from '../../images/underConstruction.svg';

export default function UnderConstruction(): React.ReactElement {
    const { t } = useTranslation();

    return (
        <Box m={8} sx={{ textAlign: 'center' }}>
            <img src={underConstruction} width={230} />

            <h1>{t('underConstruction.title')}</h1>
        </Box>
    );
}
